import { conversationClient } from '.';

export interface TextMesssage
  extends Omit<
    Conversation.Message,
    | 'videoContent'
    | 'imageContent'
    | 'itemContent'
    | 'orderContent'
    | 'stickerContent'
    | 'sysTransferContent'
  > {
  textContent: Conversation.MsgText;
}

export interface TranslateReportV2Body {
  msgId: TextMesssage['msgId'];
  translation: Conversation.Translation;
}

const overseaTranslateReport = (body: TranslateReportV2Body | TranslateReportV2Body[]) => {
  const translateReportInfo = Array.isArray(body) ? body : [body];
  return conversationClient
    .post('/translateReportV2', { translateReportInfo })
    .then(() => true)
    .catch(() => {
      return false;
    });
};

export default overseaTranslateReport;
